import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import DataTable from 'components/tables/data-table';
import { useAuth } from 'contexts';
import { downloadUngroupedCsv, fetchActiveUnitsUngrouped } from 'services';
import { defaultUnitColumns, unitDataColumns } from '../grid/unit-columns';

const AssociatedUnits: FC = () => {
  const { unitId } = useParams();
  const { userProfile } = useAuth();

  const fetchData = useMemo(() => fetchActiveUnitsUngrouped({ associatedUnitId: unitId }), [unitId]);

  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'UNIT_UNSTACKED').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'UNIT_UNSTACKED')
          .map(({ column, width }) => {
            return { field: column, width };
          })
      : defaultUnitColumns.map(c => {
          return { field: c, width: 80 };
        });
  }, [userProfile.columnPreferences]);

  return !unitId ? null : (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>ASSOCIATED UNITS</h4>
      </div>
      <div className="card-body">
        <DataTable
          fetchData={fetchData}
          fetchCsv={downloadUngroupedCsv({ associatedUnitId: unitId })}
          columns={unitDataColumns}
          initialColumns={initialColumns}
          initialPage={{ sortField: 'createdDate', sortDirection: 'desc' }}
        />
      </div>
    </div>
  );
};

export default AssociatedUnits;
